var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_126",
    "data-name": "Groupe 126",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.452,
    height: 17.452,
    viewBox: "0 0 17.452 17.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 17.452,
    height: 17.452,
    transform: "translate(0 0)",
    fill: "#e30613"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_122",
    "data-name": "Groupe 122",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_99",
    "data-name": "Trac\\xE9 99",
    d: "M11.849,10.8A6.651,6.651,0,1,0,10.8,11.849l5.889,5.889,1.045-1.045Zm-5.2,1.021a5.174,5.174,0,1,1,5.174-5.174,5.179,5.179,0,0,1-5.174,5.174",
    transform: "translate(0 0)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_100",
    "data-name": "Trac\\xE9 100",
    d: "M15.39,11.874H14.205v2.37H11.874v1.185h2.331v2.292H15.39V15.429h2.331V14.244H15.39Z",
    transform: "translate(-8.146 -8.146)",
    fill: "#e30613"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoom);
export default __webpack_public_path__ + "static/media/icon-zoom.0cb839bb3ddd394b81e18dd9b3bf0ef4.svg";
export { ForwardRef as ReactComponent };